export default "__VITE_ASSET__FNZWmrg$__"